<template>
<div id="app">
    <router-view :userdata="userdata"></router-view>
</div>
</template>

<script>

export default {
    name: 'App',
    data: function() {
        let userdata = {};

        if (this.$route.query.left) {
            userdata[this.$route.query.left] = {};
        }

        if (this.$route.query.right) {
            userdata[this.$route.query.right] = {};
        }

        return {
            userdata: userdata
        };
    },
    methods: {
        loadData: async function() {
            this.left = this.$route.query.left;
            this.right = this.$route.query.right;

            if (this.left !== undefined) {
                let leftResponse = await $.ajax({
                    url: `http://www.hi-izuru.org/octgn_testing/user.php?name=${this.left}`,
                    dataType: "json"
                });

                this.userdata[this.left] = leftResponse[0];
            }

            if (this.right !== undefined) {
                let rightResponse = await $.ajax({
                    url: `http://www.hi-izuru.org/octgn_testing/user.php?name=${this.right}`,
                    dataType: "json"
                });

                this.userdata[this.right] = rightResponse[0];
            }
        }
    },
    created: function() {
        this.loadData();

        setInterval(() => {
            this.loadData();
        }, 5000);
    }
}
</script>

<style>
@import "bootstrap";
</style>



// WEBPACK FOOTER //
// src/App.vue